module.exports = __webpack_public_path__ + "img/solution_forest.5fcf3032.png";